<template>
  <div class="container employee_review_counter_block">
    <div class="row employee_review_counter_block__row">
      <div class="col-sm-6 col-12">
        <default-title
          class="employee_review_counter_block-title"
          title_tag="div"
          :title="title"
        />
        <html-block
          class="mt-10"
          :content="content"
        />
      </div>
      <div class="col-sm-6 col-12">
        <div class="employee_review_counter_block-badge h-100">
          <div class="employee_review_counter_block-badge_counter">
            <counter-increase :count_to="Number(count_to_number)"/>%
          </div>
          <div class="employee_review_counter_block-badge_text">{{counter_text}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import CounterIncrease from "../small_parts/CounterIncrease.vue";
import DefaultTitle from "../small_parts/DefaultTitle.vue";
import HtmlBlock from "../small_parts/HtmlBlock.vue";

export default {
  name: "EmployeeReviewCounterBlock",
  components: {
    HtmlBlock,
    DefaultTitle,
    CounterIncrease

  },
  props: {
    /**props**/
    title: {
      type: String,
      default: '',
      admin_type: 'input',
    },
    content: {
      type: String,
      default: '',
      admin_type: 'editor',
    },
    count_to_number: {
      type: String,
      default: 0,
      admin_type: 'number',
    },
    counter_text: {
      type: String,
      default: '',
      admin_type: 'input',
    }
    /**props**/
  },
}
</script>
